import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterbyreferenceComponent } from './registerbyreference.component';

const routes: Routes = [
    {
        path: '',
        component: RegisterbyreferenceComponent,
        data: {
            title: 'Register By Reference Form'
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class RegisterbyreferenceRoutingModule { }
